module.exports = __webpack_public_path__ + "img/write.fc9310fa.png";